export default class RequestData {
  loading!: boolean;
  statusCode!: number;
  meta: any | null;
  links?: any | null;
  errors!: { message: string; errors: any; details: any } | null;
}
